document.querySelectorAll('.teca-v2__slider').forEach(slider => {

  const beforeWrapper = slider.querySelector('.teca-v2__before-wrapper');
  const handle = slider.querySelector('.teca-v2__handle');
  const divider = slider.querySelector('.teca-v2__divider');

  const beforeLabel = slider.querySelector('.teca-v2__label--before');
  const afterLabel = slider.querySelector('.teca-v2__label--after');

  let dragging = false;

  function updatePosition(x) {
    const rect = slider.getBoundingClientRect();
    let offset = x - rect.left;
    offset = Math.max(0, Math.min(offset, rect.width));

    const percent = (offset / rect.width) * 100;

    // Move slider
    beforeWrapper.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
    handle.style.left = percent + '%';
    divider.style.left = percent + '%';

    checkLabelOverlap(offset, rect);
  }

function checkLabelOverlap(dividerX, sliderRect) {

  const beforeRect = beforeLabel.getBoundingClientRect();
  const afterRect = afterLabel.getBoundingClientRect();

  const dividerGlobalX = sliderRect.left + dividerX;

  // BEFORE label logic
  // Hide if divider is left of label right edge
  if (dividerGlobalX <= beforeRect.right) {
    beforeLabel.classList.add('teca-v2__label--hidden');
  } else {
    beforeLabel.classList.remove('teca-v2__label--hidden');
  }

  // AFTER label logic
  // Hide if divider is right of label left edge
  if (dividerGlobalX >= afterRect.left) {
    afterLabel.classList.add('teca-v2__label--hidden');
  } else {
    afterLabel.classList.remove('teca-v2__label--hidden');
  }

}

  handle.addEventListener('pointerdown', e => {
    e.preventDefault();
    dragging = true;
  });

  window.addEventListener('pointerup', () => dragging = false);

  window.addEventListener('pointermove', e => {
    if (!dragging) return;
    updatePosition(e.clientX);
  });

});